import React from 'react'
import { ThemeProvider } from '@material-ui/styles'
import Routes from 'routes'
import theme from './theme'
import ErrorBoundary from 'components/ErrorBoundary/Component'
import * as firebase from 'firebase/app'
import 'firebase/functions'
import { firebaseConfig } from 'config'
import TagManager from 'react-gtm-module'
 

import './styles/common.sass'

const App: React.FC = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig).functions()
  }

  TagManager.initialize({
    gtmId: 'GTM-W4QVHX6',
    auth: 'r0e-Ry99rPBmH4k5IXqFQw',
    preview: 'env-2'
  })

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
